const dataLabels = {
  n: { label: 'Name', format: 'left' },
  p: { label: 'Public Health Region (PHR)' },
  d: { label: 'doses distributed' },
  a: {
    label: 'shots administered',
    btnLabel: 'shots administered',
  },
  '1': { label: 'first shots administered' },
  '2': { label: 'second shots administered' },
  part: { label: 'partially vaccinated' }, //calculated as '1' - '2'
  '16+': { label: 'population 16+' },
  '65+': { label: 'population, 65+' },
  h: { label: 'Population, Phase A1 Healthcare Workers' },
  l: { label: 'Population, Phase A1 Long-term Care Residents' },
  pv: {
    label: 'percent vaccinated with at least one dose',
    format: 'percent',
    btnLabel: 'First dose',
  },
  ppartv: {
    label: 'percent partially vaccinated',
    format: 'percent',
    btnLabel: 'Partially vaccinated',
  },
  pvf: {
    label: 'percent fully vaccinated',
    format: 'percent',
    btnLabel: 'Fully vaccinated',
  },
  'a/100k': {
    label: 'Total doses administered per 100K',
    btnLabel: 'Doses per 100K',
  },
  pd: {
    label: 'percent of shipped doses administered',
    format: 'percent',
  },
  pop: {
    label: 'population',
  },
  first_dose_coverage: {
    label: 'Percentage of population that has received a first dose',
    format: 'percent',
  },
  PctVaccinatedPopulation: {
    label: 'Percentage of population that has been fully vaccinated',
    format: 'percent',
  },
  pct_fv: {
    label: 'Percentage received all shots',
    format: 'percent',
    btnLabel: 'Fully vaccinated',
  },
  'pct_pv': {
    label: 'Percentage partially vaccinated',
    format: 'percent',
    btnLabel: 'First dose',
  },
  'num_fv':{
    label: 'Received all shots'
  },
  'num_pv':{
    label: 'Partially vaccinated'
  },
  'administered':{
    label: 'Doses administered'
  },
  'atleast':{
    label: 'People who received at least one dose'
  }
}

export { dataLabels }
